// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "disclaimer-28sZ8";
var _3 = "disclaimer__inner-1tEER";
var _4 = "disclaimer__icon-VAthV";
var _5 = "disclaimer__paragraph-293Fy";
export { _1 as "__esModule", _2 as "disclaimer", _3 as "disclaimer__inner", _4 as "disclaimer__icon", _5 as "disclaimer__paragraph" }
export default { "__esModule": _1, "disclaimer": _2, "disclaimer__inner": _3, "disclaimer__icon": _4, "disclaimer__paragraph": _5 }
